import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("link", {
  rel: "stylesheet",
  href: "https://unpkg.com/bpmn-js@17.11.1/dist/assets/bpmn-js.css"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("link", {
  rel: "stylesheet",
  href: "https://unpkg.com/bpmn-js@17.11.1/dist/assets/diagram-js.css"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("link", {
  rel: "stylesheet",
  href: "https://unpkg.com/bpmn-js@17.11.1/dist/assets/bpmn-font/css/bpmn.css"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_JoinExistingMeeting = _resolveComponent("JoinExistingMeeting")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_router_view),
    (_ctx.showJoinMeeting)
      ? (_openBlock(), _createBlock(_component_JoinExistingMeeting, {
          key: 0,
          meetings: _ctx.activeMeetings,
          onMeetingSelected: _ctx.handleMeetingSelected
        }, null, 8, ["meetings", "onMeetingSelected"]))
      : _createCommentVNode("", true)
  ], 64))
}